/* =============================================================================
   Mundo TEC · cuotas en las tarjetas de producto
   -----------------------------------------------------------------------------
   Escribe "6 x S/ 29.84" debajo del precio de cada tarjeta que llega al umbral
   de cuotas sin interes.

   Por que en JS y no en el Liquid de la tarjeta: `snippets/card-product.liquid`
   es del tema base (Elixira es de pago y se actualiza). Tocarlo significaria
   perder el modulo en la proxima actualizacion. Este script decora las tarjetas
   ya renderizadas y no toca ni un archivo del tema.

   El precio se lee del DOM (`.price-item--last`, que es el precio final tanto en
   la rama normal como en la de oferta) y se reusa el prefijo de moneda que ya
   trae la tienda, para no hardcodear "S/".

   Los filtros de coleccion reemplazan la grilla entera, asi que hay un
   MutationObserver que vuelve a decorar lo que aparezca.

   Config: window.MT_CARDS = { umbral: <centimos>, cuotas: <n> }
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.MT_CARDS || {};
  var UMBRAL = cfg.umbral || 14900; // centimos
  var CUOTAS = cfg.cuotas || 6;

  // "S/. 1,234.56" -> { prefijo: "S/.", centimos: 123456 }
  function parseMoney(txt) {
    if (!txt) return null;
    var limpio = txt.replace(/\s+/g, ' ').trim();
    var m = limpio.match(/^([^\d]*)([\d.,]+)/);
    if (!m) return null;
    var numero = m[2];
    // Formato peruano: la coma separa miles, el punto los decimales.
    numero = numero.replace(/,/g, '');
    var val = parseFloat(numero);
    if (isNaN(val)) return null;
    return { prefijo: m[1].trim(), centimos: Math.round(val * 100) };
  }

  function formatear(prefijo, centimos) {
    var s = (centimos / 100).toFixed(2);
    return prefijo ? prefijo + ' ' + s : s;
  }

  function decorar(raiz) {
    var precios = (raiz || document).querySelectorAll('.card-information .price, .card__content .price');

    Array.prototype.forEach.call(precios, function (precio) {
      if (precio.dataset.mtCuotas) return;
      precio.dataset.mtCuotas = 'visto';

      var ultimo = precio.querySelector('.price-item--last');
      if (!ultimo) return;

      var dato = parseMoney(ultimo.textContent);
      // Por debajo del umbral no hay cuotas sin interes: no se anuncia nada.
      if (!dato || dato.centimos < UMBRAL) return;

      var cuota = Math.ceil(dato.centimos / CUOTAS);
      var nota = document.createElement('span');
      nota.className = 'mt-card-cuotas';
      nota.textContent = CUOTAS + ' x ' + formatear(dato.prefijo, cuota) + ' sin interés';
      precio.insertAdjacentElement('afterend', nota);
    });
  }

  function iniciar() {
    decorar(document);

    var observer = new MutationObserver(function (mutaciones) {
      for (var i = 0; i < mutaciones.length; i++) {
        if (mutaciones[i].addedNodes.length) {
          decorar(document);
          return;
        }
      }
    });

    var grilla = document.querySelector('#ProductGridContainer') || document.body;
    observer.observe(grilla, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
